export const SXA_DEFAULT_LOADER = {
  desktop: `
<div class="cui">
  <div class="-background--lightgray -spacing--padding-top-120 -spacing--padding-bottom-120" style="height: 480px;">
    <div class="cui-grid cui-container">
      <div style="width: 66.67%">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 4rem;"></div>
        </div>
        <div class="cui-skeleton-rectangle -is--block -spacing--top-8">
          <div class="cui-skeleton__item" style="width: 50%; height: 4rem;"></div>
        </div>
        <div class="cui-skeleton-paragraph -resolution--desktop -spacing--top-24">
          <div class="cui-skeleton-paragraph__content" style="width: 100%;">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="-spacing--padding-top-80 -spacing--padding-bottom-80">
    <div class="cui-grid cui-container">
      <div style="display: flex; flex-wrap: nowrap;">
        <div style="flex: 1 1 32%">
          <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--padding-right-32">
            <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
              <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
              <div class="cui-skeleton__item cui-skeleton__description"></div>
            </div>
          </div>
        </div>
        <div style="flex: 1 1 68%">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="height: 25rem;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="-spacing--padding-top-80 -spacing--padding-bottom-80">
    <div class="cui-grid cui-container">
      <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-48">
        <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
          <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        </div>
      </div>
      <div class="cui-row -gap--v-40">
        <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
          </div>
        </div>
        <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
          </div>
        </div>
        <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
          </div>
        </div>
        <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
          </div>
        </div>
        <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
          </div>
        </div>
        <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
  mobile: `
<div class="cui">
  <div class="-background--lightgray" style="height: 240px;"></div>
  <div class="cui-grid cui-container -spacing--padding-top-24 -spacing--padding-bottom-24">
    <div class="cui-skeleton-heading -size--large -resolution--mobile">
      <div  class="cui-skeleton-heading__content -width--full">
        <div class="cui-skeleton__item cui-skeleton-heading__title -width--full"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
      </div>
    </div>
  </div>
  <div style="border-bottom: 1px solid #E8E8E8"></div>
  <div class="cui-grid cui-container -spacing--padding-top-32 -spacing--padding-bottom-32">
    <div class="cui-skeleton-heading -size--large -resolution--mobile">
      <div  class="cui-skeleton-heading__content -width--full">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
        <div class="cui-skeleton__item cui-skeleton__description"></div>
      </div>
    </div>
    <div class="cui-skeleton-rectangle -is--block -spacing--top-24">
      <div class="cui-skeleton__item" style="height: 15rem;"></div>
    </div>
  </div>
  <div class="cui-grid cui-container -spacing--padding-top-32 -spacing--padding-bottom-32">
    <div class="cui-skeleton-heading -size--large -resolution--mobile -spacing--bottom-24">
      <div  class="cui-skeleton-heading__content -width--full">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      </div>
    </div>
    <div class="cui-row -gap--v-24">
      <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
        </div>
      </div>
      <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
        </div>
      </div>
      <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
        </div>
      </div>
      <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
        </div>
      </div>
      <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
        </div>
      </div>
      <div class="cui-col-sm-4 cui-col-md-4 cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="height: 11.75rem;"></div>
        </div>
      </div>
    </div>
  </div>
</div>`
};
